import { computed } from "vue";
import { IFilterProvider } from "./interfaces/filter-providers/IFilterProvider";
import { FilterOptionInformation } from "./models/FilterOptionInformation";
import { FilterKey } from "./models/FilterKey";

export default abstract class Filter {
	public key: FilterKey;
	public filterOptions: readonly FilterOptionInformation[];
	public filterProvider: IFilterProvider;

	public collapsed = computed((): boolean => {
		return this.filterProvider.isFilterCollapsed(this.key);
	});

	public filterHintCount = computed((): number => {
		return this.filterProvider.getFilterSelection(this.key).length;
	});

	constructor(key: FilterKey, filterProvider: IFilterProvider) {
		this.key = key;
		this.filterProvider = filterProvider;
		this.filterOptions = this.filterProvider.getFilterOptionInformation(this.key);
	}

	public toggleFilter(): void {
		this.filterProvider.toggleFilterExpandability(this.key);
	}
}
